import { renderStatusCell } from 'ui/table/StatusCell';

export const renderNotificationStatusCell = renderStatusCell(
    { DONE: 'green', PENDING: 'yellow', DRAFT: 'yellow', ERROR: 'red' },
    'green',
    { DONE: 'Sent' }
);
